export default __webpack_public_path__ + "static/media/session1.709839c5.svg";